export const AUTOMATIC = {
  FETCH: "AUTOMATIC.FETCH",
  FETCH_SUCCESS: "AUTOMATIC.FETCH_SUCCESS",
  FETCH_ERROR: "AUTOMATIC.FETCH_ERROR",
  SET_FILTER: "AUTOMATIC.SET_FILTER",
  SET_PAGE_INDEX: "AUTOMATIC.SET_PAGE_INDEX",
  SET_SORT_COLUMN: "AUTOMATIC.SET_SORT_COLUMN",
  SET_SORT_DESC: "AUTOMATIC.SET_SORT_DESC",
  SET_TAB_INDEX: "AUTOMATIC.SET_TAB_INDEX"
};

export default AUTOMATIC;
